module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8411/img/InterstitialBlobs.png"